var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-o-d-10-2023-any-object-report')
}
var staticRenderFns = []

export { render, staticRenderFns }